import moment from "moment";


export function dateFormat(date, format= 'YYYY/MM/DD(ddd)') {
    moment.locale("ja")
    const m = moment(date)
    if(!m.isValid()) return ''
    return m.format(format)
}



// WEBPACK FOOTER //
// ./resources/assets/js/utility/dateUtility.js